module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_5012.68793ce4.png";